export const COMMITMENT_DAYS = Object.freeze([
  { id: "monday", labelKey: "common.days.monday" },
  { id: "tuesday", labelKey: "common.days.tuesday" },
  { id: "wednesday", labelKey: "common.days.wednesday" },
  { id: "thursday", labelKey: "common.days.thursday" },
  { id: "friday", labelKey: "common.days.friday" },
  { id: "saturday", labelKey: "common.days.saturday" },
  { id: "sunday", labelKey: "common.days.sunday" },
]);

export const COMMITMENT_SLOTS = Object.freeze([
  { id: "morning", labelKey: "home.profileSections.commitment.slots.morning" },
  { id: "day", labelKey: "home.profileSections.commitment.slots.day" },
  { id: "evening", labelKey: "home.profileSections.commitment.slots.evening" },
  { id: "night", labelKey: "home.profileSections.commitment.slots.night" },
]);

export const COMMITMENT_FREQUENCY = Object.freeze([
  { id: "1-2", labelKey: "home.profileSections.commitment.frequency.oneTwo" },
  { id: "3-5", labelKey: "home.profileSections.commitment.frequency.threeFive" },
  { id: "full-time", labelKey: "home.profileSections.commitment.frequency.fullTime" },
]);
